"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _BasePlayer2 = _interopRequireDefault(require("../BasePlayer"));
var _VideoTimeHelpers = _interopRequireDefault(require("../utils/VideoTimeHelpers"));
var _extractPlayablesFromConfig = _interopRequireDefault(require("../utils/extractPlayablesFromConfig"));
var _AdUtils = require("./AdUtils");
var _PlayablesMutation = _interopRequireDefault(require("./PlayablesMutation"));
var _listeners = require("./listeners");
var _registry = _interopRequireDefault(require("../../utils/registry"));
var _QualityUtils = require("../utils/QualityUtils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Module that provides the `JwWrapper` class.
 *
 * @module JwWrapper
 */
var JW_VERSION = '8.2.0';
var JW_PLAYER_NAME = 'JW';
var PAUSED = 'paused';
var IDLE = 'idle';

/**
 * Class for the JWPlayer that implements and overrides the relevant methods
 * from the {BasePlayer} class.
 * @class JwWrapper
 * @extends {BasePlayer}
 */
var JwWrapper = exports["default"] = /*#__PURE__*/function (_BasePlayer) {
  /**
   * Create an instance of JwWrapper
   * @param {InternalPlayerConfig} config - The player configuration object
   */
  function JwWrapper(config) {
    var _this;
    _classCallCheck(this, JwWrapper);
    _this = _callSuper(this, JwWrapper, [config]);
    /** @ignore */
    _defineProperty(_this, "_playableMutations", []);
    _defineProperty(_this, "_temporaryPlayingIndex", void 0);
    _defineProperty(_this, "_compatibilityTester", null);
    if (typeof config.frameAccurateSeekEnabled !== 'undefined') {
      _this._warnUsage('frameAccurateSeekEnabled');
    }

    /** @ignore */
    _this._playerState = {
      error: null,
      initialized: false,
      seeking: false,
      paused: !config.autoplay
    };

    /** @ignore */
    _this._qualities = (0, _QualityUtils.qualitiesRecord)();
    // Needed for BasePlayer._emitTimeUpdate
    _this._onEnded = _listeners.onEnded.bind(_this);
    return _this;
  }

  /**
   * Bind the events of the underlying player.
   * @override
   */
  _inherits(JwWrapper, _BasePlayer);
  return _createClass(JwWrapper, [{
    key: "bindPlayerEvents",
    value: function bindPlayerEvents() {
      this.rawPlayer.on('adImpression', _listeners.onAdBegin.bind(this));
      this.rawPlayer.on('adSkipped', _listeners.onAdEnded.bind(this));
      this.rawPlayer.on('adComplete', _listeners.onAdEnded.bind(this));
      this.rawPlayer.on('buffer', _listeners.onBuffer.bind(this));
      this.rawPlayer.on('complete', this._onEnded);
      this.rawPlayer.on('error', _listeners.onError.bind(this));
      this.rawPlayer.on('firstFrame', _listeners.onLoadStart.bind(this));
      this.rawPlayer.on('fullscreen', _listeners.onFullScreenChange.bind(this));
      this.rawPlayer.on('levels', _listeners.onQualitiesLoaded.bind(this));
      this.rawPlayer.on('mute', _listeners.onVolumeChange.bind(this));
      this.rawPlayer.on('pause', _listeners.onPause.bind(this));
      this.rawPlayer.on('play', _listeners.onPlay.bind(this));
      this.rawPlayer.on('playlistItem', _listeners.onPlaylistItem.bind(this));
      this.rawPlayer.on('ready', _listeners.onInitialized.bind(this));
      this.rawPlayer.on('seeked', _listeners.onSeeked.bind(this));
      this.rawPlayer.on('seek', _listeners.onSeeking.bind(this));
      this.rawPlayer.on('setupError', _listeners.onSetupError.bind(this));
      this.rawPlayer.on('visualQuality', _listeners.onQualityChanged.bind(this));
      this.rawPlayer.on('volume', _listeners.onVolumeChange.bind(this));

      // Binds the default time event if no timeUpdateInterval is provided
      if (!this.config.hasOwnProperty('timeUpdateInterval') || typeof this.config.timeUpdateInterval !== 'number') {
        this.rawPlayer.on('time', _listeners.onTimeUpdate.bind(this));
      }
    }
  }, {
    key: "version",
    get:
    /**
     * Gets the version of the THEOplayer used.
     * @type {string}
     */
    function get() {
      return JwWrapper._version;
    }

    /**
     * Gets the name of the player.
     * @type {string}
     */
  }, {
    key: "name",
    get: function get() {
      return JwWrapper._name;
    }

    /**
     * Script loaded handler.
     * @private
     */
  }, {
    key: "_onPlayerLoaded",
    value: function _onPlayerLoaded() {
      // this will prevent creation if we are destroyed
      // before the player is loaded
      if (this._destroyedBeforeCreated) {
        return;
      }
      this.logger.times.LoadTimeScript = performance.now() - this.logger.times.LoadTimeScript;
      this.logger.times.LoadTimeVideo = -1;
      this.logger.logTime('LoadTime-Script', this.logger.times.LoadTimeScript);
      this.logger.times.LoadTimeInit = performance.now();
      window.jwplayer.key = '/gIG/kPuSEtv2xjMFZ6vtYsI7Wx1Ih73QvGi/w==';
      var container = this.getVideoContainer();
      var video = container.appendChild(document.createElement('div'));
      video.id = this.videoDOMId;

      /** @ignore */
      this.rawPlayer = window.jwplayer(video);
      if (this.config.playables && this.config.playables.length > 0) {
        this.setup();
      } else {
        this.logger.times.LoadTimeInit = -1;
      }
    }
  }, {
    key: "setup",
    value: function setup() {
      var setupObj = {
        stretching: 'uniform',
        controls: false,
        width: '100%',
        aspectratio: '16:9',
        autostart: this.config.autoplay ? 'viewable' : false,
        mute: !!this.config.muted,
        abouttext: 'Hudl Video Player',
        aboutlink: 'http://www.hudl.com/',
        advertising: {
          client: 'googima',
          autoplayadsmuted: !!this.config.muted,
          vpaidcontrols: true,
          vpaidmode: 'enabled'
        }
      };

      // If source is specified then set it for the player, otherwise if a
      // playlist is set map it to the JW Player playlist format
      setupObj.playlist = (0, _extractPlayablesFromConfig["default"])(this.config.playables, window.location, _AdUtils.getPlayableAds, 'adschedule', 'file');
      this.rawPlayer.setup(setupObj);
      this.bindPlayerEvents();
    }

    /**
     * Removes the player from the DOM and cleans up all resources.
     * @override
     */
  }, {
    key: "destroy",
    value: function destroy() {
      clearTimeout(this._liveStatusPollTimeout);
      if (this.rawPlayer) {
        this.rawPlayer.remove();
        if (this.activityTracker) {
          this._cleanupActivityTracking();
        }
        if (this._compatibilityTester) {
          this._cleanupCompatibilityTestListener();
        }

        // delete the wrapping dom node
        var wrapper = this.getVideoContainer();
        wrapper.parentElement.removeChild(wrapper);

        // remove player from registry
        delete _registry["default"].jw.players[this.id];
      } else {
        this._destroyedBeforeCreated = true;
      }
    }

    /**
     * Play the player's video source.
     * @override
     */
  }, {
    key: "play",
    value: function play() {
      this._playerState.autoplayNewPlayable = false;
      if (this._playerState.goToStart) {
        this._playerState.goToStart = false;
        this.currentTime = 0;
      }
      if (!this.config.autoplay && this.logger.times.LoadTimeVideo === -1) {
        this.logger.times.LoadTimeVideo = performance.now();
      }
      this._playerState.paused = false;
      this.rawPlayer.play();
    }

    /**
     * Pause the player's video source.
     * @override
     */
  }, {
    key: "pause",
    value: function pause() {
      this._playerState.paused = true;
      this.rawPlayer.pause();
    }

    /**
     * Returns the video aspectRatio if visualQuality is returned
     * @type {number}
     */
  }, {
    key: "aspectRatio",
    get: function get() {
      var defaultAspectRatio = 16 / 9;
      var visualQuality = this.rawPlayer.getVisualQuality();
      if (!visualQuality || !visualQuality.level) {
        return defaultAspectRatio;
      }
      var _visualQuality$level = visualQuality.level,
        width = _visualQuality$level.width,
        height = _visualQuality$level.height;
      return width && height ? width / height : defaultAspectRatio;
    }

    /**
     * Returns whether the player should automatically advance to the next clip.
     */
  }, {
    key: "autoAdvance",
    get: function get() {
      return this._autoAdvance;
    }

    /**
     * Sets whether the player should automatically advance to the next clip.
     */,
    set: function set(a) {
      this._autoAdvance = a;
    }

    /**
     * Returns whether the video is configured to start playing automatically.
     * @override
     */
  }, {
    key: "autoplay",
    get: function get() {
      return !!this.config.autoplay;
    }

    /**
     * Sets the autoplay functionality
     * @override
     */,
    set: function set(a) {
      // eslint-disable-line no-unused-vars
      this.config.autoplay = a;
    }

    /**
     * Returns whether the playlist clip is configured to start playing automatically.
     * @type {boolean}
     */
  }, {
    key: "autoPlayClips",
    get: function get() {
      return this._autoPlayClips;
    }

    /**
     * Sets whether the playlist clip should start playing automatically on load.
     * @type {boolean}
     */,
    set: function set(a) {
      this._autoPlayClips = a;
    }

    /**
     * Returns the current video's filled buffer, as a percentage (0 to 100)
     * of the total video's length.
     * @type {number}
     * @override
     */
  }, {
    key: "buffered",
    get: function get() {
      return this.rawPlayer.getBuffer();
    }

    /**
     * Returns the currently playing video quality object.
     * @type {Quality}
     * @override
     */
  }, {
    key: "currentQuality",
    get: function get() {
      if (this._qualities.normalised.length === 0) {
        return null;
      }
      var index = this.rawPlayer.getCurrentQuality();
      var quality = Object.assign({}, this._qualities.normalised.find(function (n) {
        return n.index === index;
      }));
      if (quality.label === _QualityUtils.AUTO_LABEL) {
        var currentVisual = this.rawPlayer.getVisualQuality();
        if (currentVisual && currentVisual.level.height) {
          quality.label = "".concat(_QualityUtils.AUTO_LABEL, " (").concat(currentVisual.level.height, "p)");
        }
      }
      return quality;
    }

    /**
     * Set the quality for video playback using the video quality object specific
     * for each player.
     * @type {Quality}
     * @override
     */,
    set: function set(q) {
      if (this._qualities.normalised.length === 0) {
        return;
      }
      if (q.key) {
        var emitEvent = false;
        var currentQuality = this.rawPlayer.getVisualQuality();
        var quality = this._qualities.normalised.find(function (n) {
          return n.key === q.key;
        });

        // JWPlayer doesn't emit quality changed events if quality doesn't change from
        // current playing auto level
        if (currentQuality.mode === _QualityUtils.AUTO_LABEL.toLowerCase() && currentQuality.level.index === quality.index) {
          emitEvent = true;
        }
        this.rawPlayer.setCurrentQuality(quality.index);
        if (emitEvent) {
          this.emit('qualitychanged');
        }
      } else {
        this._warnUsage('Setting a quality without a key');
      }
    }

    /**
     * Get the manifest URL for the video that is currently playing.
     * @type {string}
     * @override
     */
  }, {
    key: "currentSrc",
    get: function get() {
      return this.rawPlayer.getPlaylistItem(this.rawPlayer.getPlaylistIndex()).file;
    }

    /**
     * Alias to player.playables[player.playingIndex]
     *
     * @override
     * @return {Playable|null} Current Playable
     */
  }, {
    key: "currentPlayable",
    get: function get() {
      return this.playables[this.playingIndex];
    }

    /**
     * Returns the index of the playing playble from player.playables.
     * @override
     * @return {number}
     */
  }, {
    key: "playingIndex",
    get: function get() {
      return this._temporaryPlayingIndex || this.rawPlayer && this.rawPlayer.getPlaylistIndex && this.rawPlayer.getPlaylistIndex();
    }

    /**
     * Sets the src of the video to the index of playables requested.
     * This will then trigger a few events with loading a new video
     *
     * @override
     * @param {number} index to set the playing index to
     */,
    set: function set(index) {
      if (index !== this.playingIndex) {
        this.rawPlayer.playlistItem(index);
      } else {
        // otherwise the player silently crashes
        this.currentTime = 0;
        _listeners.onPlaylistItem.call(this, {
          index: index
        });
      }
      if (this._autoPlayClips) {
        this.play();
      }
    }

    /**
     * Get the current playback position in the video (in seconds).
     * @type {number}
     * @override
     */
  }, {
    key: "currentTime",
    get: function get() {
      // setting currentTime is not synchroneous, so if you set
      // and read immediately, the value will not be as expected
      // this state variable helps us make it act synchroneous
      // The variable gets cleared in the onSeeked listener
      if (this._playerState.temporaryMarkerWhileSeeking) {
        return this._playerState.temporaryMarkerWhileSeeking;
      }
      if (this.rawPlayer.getPosition) {
        var startOffset = this.currentPlayable.startTime || 0;
        return (this.rawPlayer.getPosition() || 0) - startOffset;
      }
      return 0;
    }

    /**
     * Set the current playback position in the video (in seconds).
     * @type {number}
     * @override
     */,
    set: function set(t) {
      var startOffset = this.currentPlayable.startTime || 0;

      // setting currentTime is not synchroneous, so if you set
      // and read immediately, the value will not be as expected
      // this state variable helps us make it act synchroneous
      // The variable gets cleared in the onSeeked listener
      this._playerState.temporaryMarkerWhileSeeking = t;
      this.rawPlayer.seek(t + startOffset);
    }

    /**
     * Get the length of the currently loaded video (in seconds), if available.
     * @type {number}
     * @override
     */
  }, {
    key: "duration",
    get: function get() {
      if (!this.currentPlayable) return 0;
      return _VideoTimeHelpers["default"].getDuration(this.currentPlayable || {}, this.rawPlayer.getDuration && this.rawPlayer.getDuration());
    }
  }, {
    key: "_rawDuration",
    get: function get() {
      return this.rawPlayer.getDuration && this.rawPlayer.getDuration() || 0;
    }

    /**
     * Returns whether the video playback has ended or not.
     * @type {boolean}
     * @override
     */
  }, {
    key: "ended",
    get: function get() {
      return this.currentTime >= this.duration;
    }

    /**
     * Returns an object representing the error state of the video.
     * @type {object}
     * @override
     */
  }, {
    key: "error",
    get: function get() {
      return this._playerState.error;
    }

    /**
     * Returns whether the video player was initialized or not.
     * @type {boolean}
     * @override
     */
  }, {
    key: "initialized",
    get: function get() {
      return this._playerState.initialized;
    }

    /**
     * Returns whether the video playback was paused or not.
     * @type {boolean}
     * @override
     */
  }, {
    key: "paused",
    get: function get() {
      if (!this.rawPlayer.getState) {
        return null;
      }
      var state = this.rawPlayer.getState();
      switch (state) {
        case PAUSED:
        case IDLE:
          return true;
        default:
          return false;
      }
    }

    /**
     * Returns whether the user is currently seeking in the video.
     * @type {boolean}
     * @override
     */
  }, {
    key: "seeking",
    get: function get() {
      return this._playerState.seeking;
    }

    /**
     * Returns whether the audio output of the video is muted or not.
     * @type {boolean}
     * @override
     */
  }, {
    key: "muted",
    get: function get() {
      return this.rawPlayer.getMute ? this.rawPlayer.getMute() : null;
    }

    /**
     * Sets the state of the audio output to muted or not.
     * @type {boolean}
     * @override
     */,
    set: function set(m) {
      this.rawPlayer.setMute(m);
    }

    /**
     * Returns the current source of the video player.
     * @type {string}
     * @override
     */
  }, {
    key: "src",
    get: function get() {
      return this.rawPlayer.getPlaylistItem ? this.rawPlayer.getPlaylistItem() && this.rawPlayer.getPlaylistItem().file : null;
    }

    /**
     * Returns the volume level of the audio output in the [0, 1] range.
     * @type {number}
     * @override
     */
  }, {
    key: "volume",
    get: function get() {
      return this.rawPlayer.getVolume ? this.rawPlayer.getVolume() / 100 : null;
    }

    /**
     * Sets the volume level of the audio output for the video.
     * @type {number}
     * @override
     */,
    set: function set(v) {
      var newVolume = Math.min(100, Math.max(0, v * 100));
      this.rawPlayer.setVolume(newVolume);
    }

    /**
     * Gets the widht of the video player.
     * @type {number}
     * @override
     */
  }, {
    key: "width",
    get: function get() {
      return this.rawPlayer.getWidth();
    }

    /**
     * Sets the width for the video player.
     * @type {number}
     * @override
     */,
    set: function set(w) {
      if (Object.keys(this.rawPlayer).length === 0) {
        return;
      }
      var ratio = this.rawPlayer.getWidth() / this.rawPlayer.getHeight();
      this.rawPlayer.resize(w, w / ratio);
    }

    /**
     * Gets the height of the video player.
     * @type {number}
     * @override
     */
  }, {
    key: "height",
    get: function get() {
      return this.rawPlayer.getHeight();
    }

    /**
     * Sets the height for the video player.
     * @type {number}
     * @override
     */,
    set: function set(h) {
      if (Object.keys(this.rawPlayer).length === 0) {
        return;
      }
      var ratio = this.rawPlayer.getWidth() / this.rawPlayer.getHeight();
      this.rawPlayer.resize(h * ratio, h);
    }

    /**
     * Returns the available qualities for the loaded video
     * @type {Quality[]}
     * @override
     */
  }, {
    key: "qualities",
    get: function get() {
      return this._qualities.normalised.slice();
    }

    /**
     * Checks if the video player supports slow rewind.
     * @type {boolean}
     * @override
     */
  }, {
    key: "canPlaySlowBackward",
    get: function get() {
      return false;
    }

    /**
     * Checks if the video player supports fast rewind.
     * @type {boolean}
     * @override
     */
  }, {
    key: "canPlayFastBackward",
    get: function get() {
      return false;
    }

    /**
     * Checks if the video player supports slow forward playback.
     * @type {boolean}
     * @override
     */
  }, {
    key: "canPlaySlowForward",
    get: function get() {
      return false;
    }

    /**
     * Checks if the video player supports fast forward playback.
     * @type {boolean}
     * @override
     */
  }, {
    key: "canPlayFastForward",
    get: function get() {
      return false;
    }

    /**
     * Checks if the video player supports frame accurate seeking.
     * @type {boolean}
     * @override
     */
  }, {
    key: "canSeekByFrame",
    get: function get() {
      return false;
    }

    /**
     * Returns true if the stream is live,  false otherwise.
     * @type {boolean}
     */
  }, {
    key: "live",
    get: function get() {
      return false;
    }

    /**
     * Used on live streams,  returns the anticipated final duration of the stream.
     * Will be equal to `duration` on VOD streams.  Just returns duration on JWPlayer.
     * @type {number}
     */
  }, {
    key: "expectedDuration",
    get: function get() {
      return this.duration;
    }

    /**
     * Gets the playables this video is going through.
     *
     * @override
     * @return {Playable[]} Copy of the playables in source with exposed manipulation APIs
     */
  }, {
    key: "playables",
    get: function get() {
      var playables = _PlayablesMutation["default"].getPlayables(this.rawPlayer, this._playableMutations);
      playables.insert = _PlayablesMutation["default"].insert.bind(this);
      playables.remove = _PlayablesMutation["default"].remove.bind(this);
      playables.push = _PlayablesMutation["default"].push.bind(this);
      return playables;
    }

    /**
     * Overrides the playables we have in source and starts the whole
     * video over at 0.
     *
     * @param {Playable[]} Array of playables
     */,
    set: function set(playables) {
      // Do nothing there is a race when we start videos with autoplay and when
      // video interface decides to call this causing both to happen.
    }

    /**
     * @param {boolean} hide
     */
  }, {
    key: "hideSpinner",
    set: function set(hide) {
      var container = this.getVideoContainer();
      if (!container) {
        return;
      }
      var classIndex = container.className.indexOf('vjs-hide-spinner');
      if (hide && classIndex === -1) {
        container.className += ' vjs-hide-spinner';
      } else if (!hide && classIndex !== -1) {
        container.className = container.className.replace(' vjs-hide-spinner', '');
      }
    }
  }], [{
    key: "_name",
    get: function get() {
      return JW_PLAYER_NAME;
    }
  }, {
    key: "_version",
    get: function get() {
      return JW_VERSION;
    }
  }]);
}(_BasePlayer2["default"]);